export function exact(regex) {
  return new RegExp(`^${regex.source}$`, regex.flags);
}
export function extractValuesFromMatch(match) {
  return match.slice(1).filter(val => val !== undefined);
}
export const cssNumberMatcher = /[+-]?(?=\.\d|\d)\d*(?:\.\d+)?(?:[eE][+-]?\d+)?/;
export const separatorMatcher = /(?=[,\s])\s*(?:,\s*)?/;
export const alphaSeparatorMatcher = /\s*[,\/]\s*/;